import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'full_name',
        title: i18n.t('marketing.dashboard.subset_name'),
        sortable: true,
        width: 120,
        textAlign: 'center',
        template: (row) => {
            return '<a href="/users/' + row.hashid + '/details">'+row.full_name+'</a>'
        },
    },
    {
        field: 'created_at',
        title: i18n.t('label.register_date'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'subset_profit_percent',
        title: i18n.t('marketing.dashboard.referer_percent') + ' ' + '(' + i18n.t('marketing.dashboard.percentage') + ')',
        sortable: true,
        width: 150,
        textAlign: 'center',
    },
    {
        field: 'subset_profit_amount',
        title: i18n.t('label.subset_benefit') + ' ' + '(' + i18n.t('currency.rial') + ')',
        sortable: true,
        width: 130,
        textAlign: 'center',
    },
]